module.exports = __webpack_public_path__ + "static/media/AvenirNext-Bold-01.6d556ca6.svg";